export default __webpack_public_path__ + "static/media/Toyota Material Handling.7183aa9c.png";